module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "article"
    }
  }, [_c('section', {
    staticClass: "hsMaxBox"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "0",
      "active-text-color": "#00b9cd",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    staticClass: "box-nav",
    attrs: {
      "index": "0"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('label', {
    staticClass: "boxT"
  }, [_vm._v("文章分类")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "0"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.tags), function(item, i) {
    return _c('label', [_c('el-menu-item', {
      attrs: {
        "index": _vm.tags[i].id
      }
    }, [_vm._v(_vm._s(_vm.tags[i].name))])], 1)
  })], 2)], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "10"
    }
  }, _vm._l((_vm.list), function(item, i) {
    return _c('li', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": "" + _vm.host + "/html/news/detail-" + _vm.list[i].id + ".html"
      }
    }, [_c('p', {
      staticClass: "hsDynamicLi"
    }, [_c('img', {
      staticClass: "hsDynamicTu",
      attrs: {
        "src": "" + _vm.host + "" + _vm.list[i].title_img + ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "hsDynamicLiText"
    }, [_c('label', {
      staticClass: "hsDynamicTop"
    }, [_vm._v(_vm._s(_vm.list[i].title))]), _vm._v(" "), _c('label', {
      staticClass: "hsDynamicBottom"
    }, [_vm._v(_vm._s(_vm.list[i].add_time))])])])])])
  }))], 1), _vm._v(" "), _c('i', {
    staticClass: "toTop",
    on: {
      "click": _vm.toTop
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2482f608","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article.vue
// module id = 184
// module chunks = 1